module.exports = __webpack_public_path__ + "static/no-commodity.06510e9f.png";